import type { Map as MapLibreMap } from 'maplibre-gl';

let current: MapLibreMap | null = null;

/** The app's single map, for components that need to move it (fly to a feature, fit an area). */
export function setMap(map: MapLibreMap | null): void {
  current = map;
}

export function getMap(): MapLibreMap | null {
  return current;
}
